// [목적] 강원캔버스 타이포그래피 스케일 (design_structure §3-2)
// [이유] CLAUDE.md §6-3 디자인 토큰 강제 — 폰트 크기·라인높이·웨이트는 토큰만 사용
// [사이드 이팩트] MUI 테마 typography 파생 / 모든 화면 텍스트 스타일
// [수정 시 고려사항] Pretendard(KR) + Inter(Latin) + JetBrains Mono(수치) 폰트 패밀리는 fontFamily 변경 시 일괄 동기
export const typography = {
    fontFamily: {
        sans: '"Pretendard", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        mono: '"JetBrains Mono", "SF Mono", Monaco, Menlo, Consolas, monospace',
    },
    scale: {
        'display.xl': { size: 40, line: 48, weight: 700 },
        'display.l': { size: 32, line: 40, weight: 700 },
        'heading.m': { size: 24, line: 32, weight: 600 },
        'heading.s': { size: 20, line: 28, weight: 600 },
        'body.m': { size: 16, line: 24, weight: 400 },
        'body.s': { size: 14, line: 20, weight: 400 },
        'mono.m': { size: 14, line: 20, weight: 500 },
    },
};
//# sourceMappingURL=typography.js.map